import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface ProfessionalCardData {
  userId: string;
  firstName: string;
  lastName: string;
  email?: string | null;
  color?: string | null;
  avatarUrl?: string | null;
}

@Component({
  selector: 'app-professional-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './professional-card.html',
  styleUrl: './professional-card.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfessionalCardComponent {
  @Input() professional: ProfessionalCardData | null = null;
  @Input() isSelected: boolean = false;
  @Input() primaryColor: string = '#2563eb';
  @Input() onClick: () => void = () => {};

  handleClick(): void {
    this.onClick();
  }

  getInitials(): string {
    const prof = this.professional;
    if (!prof) return '';
    const first = prof.firstName?.charAt(0).toUpperCase() || '';
    const last = prof.lastName?.charAt(0).toUpperCase() || '';
    return `${first}${last}`;
  }

  getFullName(): string {
    const prof = this.professional;
    if (!prof) return '';
    return `${prof.firstName} ${prof.lastName}`.trim();
  }

  getColor(): string {
    const prof = this.professional;
    return prof?.color || '#2563eb';
  }

  hexToRgba(hex: string, alpha: number): string {
    if (!hex || !hex.startsWith('#')) return `rgba(0, 0, 0, ${alpha})`;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
}

